/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
import * as tslib_1 from "tslib";
import { Subscriber } from '../Subscriber';
export function ignoreElements() {
  return function ignoreElementsOperatorFunction(source) {
    return source.lift(new IgnoreElementsOperator());
  };
}
var IgnoreElementsOperator = /*@__PURE__*/function () {
  function IgnoreElementsOperator() {}
  IgnoreElementsOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new IgnoreElementsSubscriber(subscriber));
  };
  return IgnoreElementsOperator;
}();
var IgnoreElementsSubscriber = /*@__PURE__*/function (_super) {
  tslib_1.__extends(IgnoreElementsSubscriber, _super);
  function IgnoreElementsSubscriber() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  IgnoreElementsSubscriber.prototype._next = function (unused) {};
  return IgnoreElementsSubscriber;
}(Subscriber);